export const OneLineWarning = ({ message, className }) => {
  return(
    <div className={`one-line-warning ${className}`}>
      <i className="mdi mdi-information buttom-radius"></i>
      <p>{message}</p>
    </div>
  )
}
